export const bankOptions = [
  { label: 'Bradesco', value: 'Bradesco' },
  { label: 'Itaú', value: 'Itaú' },
];